import { defineCommands, type CommandsOf, applyEntityDataChanges } from '../../commands/defineCommands';
import type { CanvasStoreContext } from '../../types';
import type { TextLabelData } from '../../entityTypes';

export const textlabelCommands = defineCommands({
  'textlabel.updateData': (ctx: CanvasStoreContext, event: {
    entityId: string; dataChanges: Partial<TextLabelData>;
  }): CanvasStoreContext => applyEntityDataChanges(ctx, event.entityId, event.dataChanges),
});

export type TextlabelCommand = CommandsOf<typeof textlabelCommands>;
